import { GroupBase, InputProps, StylesConfig, components } from "react-select";
import { ReactSelectItem } from "/Helpers/ReactSelectItem";
import { JSX } from "react";

interface OptionPickerInputProps {
  dropdownId: string;
  currentItem: ReactSelectItem;
  reactSelectProps: InputProps<
    ReactSelectItem,
    boolean,
    GroupBase<ReactSelectItem>
  >;
}

export const OptionPickerInputStyle: StylesConfig<
  ReactSelectItem,
  boolean,
  GroupBase<ReactSelectItem>
> = {
  input: (base, _state) => ({
    ...base,
    color: "transparent",
  }),
};

const OptionPickerInput = (props: OptionPickerInputProps): JSX.Element => {
  const { reactSelectProps, currentItem, dropdownId } = props;

  return (
    <components.Input
      {...reactSelectProps}
      type="button"
      autoComplete={undefined}
      autoCorrect={undefined}
      aria-activedescendant={undefined}
      aria-controls={`dropdown-content-${dropdownId}`}
      value={currentItem.label}
    ></components.Input>
  );
};

export default OptionPickerInput;
